// 재촬영(CAPTURE) 명령 후 수신 대기 판정 — 명령 이력 폴링 결과를 화면 상태로 변환.
// 장비 ACK(acked)·실패(failed)가 타임아웃보다 우선한다. 타임아웃이 지나도
// 촬영·업로드는 서버 주도로 계속 진행되므로, 화면은 안내만 하고 폴링을 멈춘다.
import type { DeviceCommandRecord } from '@grosync/common';

/** 이 시간 안에 장비 ACK 가 없으면 '응답 없음' 안내로 전환 (촬영 ~2초 + 업로드 + MQTT 왕복 여유) */
export const CAPTURE_WAIT_TIMEOUT_MS = 90_000;

export type CaptureWaitState =
  | { phase: 'waiting' }
  | { phase: 'acked' }
  | { phase: 'failed'; error: string | null }
  | { phase: 'timeout' };

export function resolveCaptureWait(
  records: DeviceCommandRecord[] | undefined,
  commandId: string,
  startedAtMs: number,
  nowMs: number,
): CaptureWaitState {
  const r = records?.find((c) => c.id === commandId);
  if (r?.status === 'acked') return { phase: 'acked' };
  if (r?.status === 'failed' || r?.status === 'expired') return { phase: 'failed', error: r.error };
  if (nowMs - startedAtMs >= CAPTURE_WAIT_TIMEOUT_MS) return { phase: 'timeout' };
  return { phase: 'waiting' };
}
